import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import CustomSignature from './CustomSignature';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';

const CustomSignatureModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			{...props}
			title='component.customSignature.modalTitle'
			size={Size.SM}>
			<CustomSignature onSuccess={props.onClose} />
		</BaseModal>
	);
};

export default CustomSignatureModal;
